import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';

export const ResetLinkDialog = ({ target, onClose }) => {
  const [link, setLink] = useState(null);
  const [creating, setCreating] = useState(false);

  const create = async () => {
    setCreating(true);
    try {
      const res = await axios.post(`${API}/users/${target.id}/reset-link`);
      setLink({ url: `${window.location.origin}/reset-password?token=${res.data.token}`, expiresAt: res.data.expires_at });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to create reset link');
    } finally {
      setCreating(false);
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link.url);
      toast.success('Reset link copied');
    } catch {
      toast.error('Copy failed — select the link and copy it manually');
    }
  };

  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="reset-link-dialog">
        <DialogHeader>
          <DialogTitle>Password reset link</DialogTitle>
          <DialogDescription>{target.name} · {target.email}</DialogDescription>
        </DialogHeader>
        {!link ? (
          <div className="space-y-3">
            <p className="text-sm text-slate-700">
              Creates a one-time link valid for 15 minutes. Any older unused link for this user stops working.
            </p>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose}>Cancel</Button>
              <Button onClick={create} disabled={creating} data-testid="create-reset-link-btn">
                {creating ? 'Creating…' : 'Create link'}
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            <Input readOnly value={link.url} onFocus={(e) => e.target.select()} data-testid="reset-link-value" className="font-mono text-xs" />
            <p className="text-xs text-slate-600" data-testid="reset-link-expiry">
              Expires at {new Date(link.expiresAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}. Send it by Teams or text. It works once.
            </p>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={onClose} data-testid="reset-link-done-btn">Done</Button>
              <Button onClick={copy} data-testid="copy-reset-link-btn">Copy</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
